import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface NotesState {
  notesList: unknown[];
}

const initialState: NotesState = {
  notesList: [],
};

export const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    updateNotes: (state, { payload }: PayloadAction<unknown[]>) => {
      state.notesList = payload;
      return state;
    },
  },
  extraReducers: () => {},
});

export const { updateNotes } = notesSlice.actions;
